// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

export interface AddToListReducerState {
    hasBeenAddedToList: string[];
}

const initialState: AddToListReducerState = {
    hasBeenAddedToList: [],
};

const actions = {
    "Pages/MyListDetails/SetHasBeenAddedToList": (
        draft: Draft<AddToListReducerState>,
        action: { productId: string },
    ) => {
        draft.hasBeenAddedToList.push(action.productId);
    },
};

const addToListReducer = createTypedReducerWithImmer(initialState, actions);
export type AddToListActions = BunzlActionUnion<typeof actions>;
export default addToListReducer;
